<mat-toolbar
    class="mat-elevation-z1 toolbar"
    [class.searchbar-open]="isSearchbarOpen()"
    [class.net-vote]="isNetvote()"
    [color]="toolbarColor()"
    [attr.color]="toolbarColor()"
    [class.netvote]="isNetvote()">
    @if (showLogo() || isNetvote()) {
        <img src="{{ currentLogo }}" class="logo" />
    }

    @if (!isNetvote()) {
        <span class="title">{{ currentToolbarTitle() }}</span>
    }

    <span class="topbar-spacer"></span>

    @if (!(shouldHideSearch() || isNetvote())) {
        <div class="searchbar">
            <input
                [@childAnimation]="isSearchbarOpen() ? 'open' : 'closed'"
                #searchTerm
                type="search"
                value=""
                placeholder="{{ 'General.GlobalSearch' | translate }}..."
                (keyup.enter)="search(searchTerm.value)" />
            <button (click)="toggleSearchBar()" mat-icon-button matSuffix matTooltip="{{ 'General.GlobalSearch' | translate }}">
                <mat-icon>{{ isSearchbarOpen() ? 'close' : 'search' }}</mat-icon>
            </button>
        </div>
    }
    <div>
        @if (areLanguagesLoaded) {
            <button mat-icon-button matTooltip="{{ 'General.Language' | translate }}" [matMenuTriggerFor]="languageMenu">
                <mat-icon>translate</mat-icon>
            </button>
        }
    </div>
    <div>
        <button mat-icon-button [matTooltip]="'General.MyProfile' | translate" [matMenuTriggerFor]="profileMenu">
            <mat-icon>person</mat-icon>
        </button>
    </div>
    @if (!isNetvote()) {
        <div>
            <button
                mat-icon-button
                [matTooltip]="'Notifications.Title' | translate"
                cdkOverlayOrigin
                #notificationsTrigger="cdkOverlayOrigin"
                (click)="toggleNotificationsOverlay()">
                <mat-icon
                    [matBadge]="notifications.length"
                    [matBadgeHidden]="notifications.length === 0"
                    [matBadgeOverlap]="true"
                    matBadgeSize="small"
                    matBadgeColor="accent">
                    notifications
                </mat-icon>
            </button>

            <ng-template
                #overlay
                cdkConnectedOverlay
                [cdkConnectedOverlayOrigin]="notificationsTrigger"
                [cdkConnectedOverlayOpen]="(isNotificationsOverlayOpenChange | async) ?? false"
                [cdkConnectedOverlayHasBackdrop]="true"
                cdkConnectedOverlayBackdropClass="sl-backdrop-invisible"
                (backdropClick)="toggleNotificationsOverlay(false)">
                <sl-notifications-overlay [notifications]="notifications" [isLoading]="isLoadingNotifications" />
            </ng-template>
        </div>
    }
</mat-toolbar>

<mat-menu #languageMenu="matMenu">
    <sl-language-switcher [showText]="true" />
</mat-menu>
<mat-menu #profileMenu="matMenu" xPosition="before">
    @if (!isNetvote()) {
        <button mat-menu-item (click)="goToMyProfile()">{{ 'General.MyProfile' | translate }}</button>
    }
    <button mat-menu-item (click)="logout()">{{ 'Login.Logout' | translate }}</button>
</mat-menu>
